import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormControl from '@material-ui/core/FormControl'
import manoleLogo from '../images/logo-manole.svg'
import Button from '@material-ui/core/Button'
import { connect } from 'react-redux'
import { authActions, messageActions } from '../actions'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import InputAdornment from '@material-ui/core/InputAdornment'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '340px'
  }),
  formControlPassword: {
    marginTop: '25px',
    marginBottom: '25px'
  },
  capsLockWarning: {
    margin: '16px 0',
    position: 'absolute',
    bottom: '-25px',
    color: '#212121',
    fontSize: '13px'
  },
  resetPassLink: {
    margin: '16px 0'
  },
  resetPasswordMessage: {
    fontSize: '16px',
    margin: '16px 0'
  },
  wrapperLoader: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  },
  logo: {
    margin: '0 auto',
    display: 'block'
  }
})

class ResetPassword extends Component {
  state = {
    email: '',
    senha: '',
    showPassword: false,
    showError: false,
    showCapsLockMessage: false
  }
  handleChangePassword = senha => {
    this.setState({
      senha,
      showError: false
    })
  }
  handleChangeEmail = email => {
    this.setState({
      email,
      showError: false
    })
  }
  componentDidMount() {
    document.onkeyup = this.toggleCapsLockMessage
    document.onkeydown = this.toggleCapsLockMessage
  }
  componentWillUnmount() {
    document.onkeyup = undefined
    document.onkeydown = undefined
  }
  toggleCapsLockMessage = e => {
    const flag = e.getModifierState && e.getModifierState('CapsLock')
    this.setState({
      showCapsLockMessage: flag
    })
  }
  componentWillReceiveProps(props) {
    if (props.err) {
      this.setState(state => {
        return {
          showError: true
        }
      })
    }
  }
  handleResetPassword = e => {
    const { email } = this.state
    e.preventDefault()
    this.props.authLoading(true)
    this.props
      .resetPasswordByEmail(email)
      .then(response => {
        const message = 'Um link para redefinição de senha foi enviado para o seu email.'
        this.props.history.push('/login')
        this.props.authLoading(false)
        this.props.changeMessage({ message })
      })
      .catch(error => {
        const { response = {} } = error
        let message

        if (response.status === 404) {
          message = 'Usuário não encontrado.'
        } else {
          message = 'Falha na redefinição de senha.'
        }

        this.props.authLoading(false)
        this.props.changeMessage({
          message,
          anchorOrigin: { horizontal: 'center', vertical: 'top' }
        })
      })
    return false
  }

  handleRequestNewPassword = e => {
    const { senha } = this.state
    const { match } = this.props
    e.preventDefault()
    this.props.authLoading(true)
    this.props
      .requestNewPassword({
        senha: senha,
        token: match.params.token ? match.params.token : null
      })
      .then(response => {
        const message = 'Senha definida com sucesso.'
        this.props.history.push('/login')
        this.props.changeMessage({ message })
        this.props.authLoading(false)
      })
      .catch(error => {
        const { response = {} } = error
        let message

        if (response.status === 400 && response.data === 'ResetPasswordTokenExpired') {
          message = 'Link de redefinição de senha expirado.'
        } else {
          message = 'Falha na redefinição de senha.'
        }

        this.props.authLoading(false)
        this.props.changeMessage({
          message,
          anchorOrigin: { horizontal: 'center', vertical: 'top' }
        })
      })
    return false
  }

  handleMouseDownPassword = e => {
    e.preventDefault()
    return false
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }
  renderResetPassword = () => {
    const { handleRequestNewPassword } = this

    const { classes, cadastro, err, loading } = this.props

    const { showError } = this.state

    const { senha, showCapsLockMessage } = this.state

    if (loading) {
      return (
        <div className={classes.wrapperLoader}>
          <CircularProgress className={classes.progress} />
        </div>
      )
    }

    return (
      <Paper className={classes.box} elevation={4}>
        <img src={manoleLogo} alt={'Logotipo Manole'} className={classes.logo} width={80} />
        <form
          id="form-reset-password"
          onSubmit={handleRequestNewPassword}
          className={classes.formGroup}
        >
          <FormControl fullWidth className={classes.formControlPassword}>
            <InputLabel error={!!(err && showError)} htmlFor="field-password">
              Senha
            </InputLabel>
            <Input
              value={senha}
              autoFocus
              type={this.state.showPassword ? 'text' : 'password'}
              error={!!(err && showError)}
              fullWidth
              onChange={e => {
                this.handleChangePassword(e.target.value)
              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={this.handleClickShowPassword}
                    onMouseDown={this.handleMouseDownPassword}
                  >
                    {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              id="field-password"
            />
            {showCapsLockMessage ? (
              <Typography className={classes.capsLockWarning}>
                Atenção: <strong>CAPS Lock</strong> está ligado
              </Typography>
            ) : null}
          </FormControl>
        </form>
        <Button
          variant="raised"
          fullWidth
          color="primary"
          type={'submit'}
          form={'form-reset-password'}
          disabled={!senha}
          className={classes.button}
        >
          {cadastro ? 'Cadastrar senha' : 'Cadastrar nova senha'}
        </Button>
        <Link to="/login">
          <Typography className={classes.resetPassLink} color={'primary'}>
            {'Ir para o login'}
          </Typography>
        </Link>
      </Paper>
    )
  }
  render() {
    const { handleResetPassword } = this
    const { classes, loading, err, match } = this.props
    const { email, showError } = this.state

    if (loading) {
      return (
        <div className={classes.wrapperLoader}>
          <CircularProgress className={classes.progress} />
        </div>
      )
    }
    return (
      <div className={classes.root}>
        {!match.params.token ? (
          <Paper className={classes.box} elevation={4}>
            <img src={manoleLogo} alt={'Logotipo Manole'} className={classes.logo} width={80} />
            <form
              id="request-new-password"
              onSubmit={handleResetPassword}
              noValidate
              className={classes.formGroup}
            >
              <FormControl fullWidth className={classes.formControl}>
                <InputLabel error={!!(err && showError)} htmlFor="field-email">
                  E-mail
                </InputLabel>
                <Input
                  value={email}
                  autoFocus
                  type={email}
                  error={!!(err && showError)}
                  fullWidth
                  onChange={e => {
                    this.handleChangeEmail(e.target.value)
                  }}
                  id="field-email"
                />
              </FormControl>
            </form>
            <Button
              variant="raised"
              form={'request-new-password'}
              fullWidth
              color="primary"
              type="submit"
              disabled={!email}
              className={classes.button}
            >
              Redefinir senha
            </Button>
            <Link to="/login">
              <Typography className={classes.resetPassLink} color={'primary'}>
                Voltar para o login
              </Typography>
            </Link>
          </Paper>
        ) : (
          this.renderResetPassword()
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  token: state.auth.token,
  err: state.auth.err,
  loading: state.auth.loading
})

const mapDispatchToProps = dispatch => {
  return {
    resetPasswordByEmail: email => {
      return dispatch(authActions.resetPasswordByEmail(email))
    },
    requestNewPassword: ({ senha, token }) => {
      return dispatch(authActions.handleRequestNewPassword({ senha, token }))
    },
    changeMessage: ({ message, anchorOrigin }) => {
      return dispatch(messageActions.changeMessage({ message, anchorOrigin }))
    },
    authLoading: loading => {
      return dispatch(authActions.authLoading(loading))
    }
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(withStyles(styles)(ResetPassword)))
)



// WEBPACK FOOTER //
// ./src/containers/ResetPassword.js